import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const MenuDot = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
             d="M11 20C11 21.6569 9.65685 23 8 23C6.34315 23 5 21.6569 5 20C5 18.3431 6.34315 17 8 17C9.65685 17 11 18.3431 11 20Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
             d="M23 20C23 21.6569 21.6569 23 20 23C18.3431 23 17 21.6569 17 20C17 18.3431 18.3431 17 20 17C21.6569 17 23 18.3431 23 20Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
             d="M35 20C35 21.6569 33.6569 23 32 23C30.3431 23 29 21.6569 29 20C29 18.3431 30.3431 17 32 17C33.6569 17 35 18.3431 35 20Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default MenuDot;
